/* on-menu.js — menu à tiroirs. Place les blocs de snippets/on-menu-modeles.liquid (<template
   id="onMenuTiroirs">) dans le menu existant, sans toucher à son balisage :
   - mobile (#mnav) : chaque rubrique (lien .mnav__rayon) devient une rangée lien + bouton « + » qui déplie son tiroir (Modèles avec
     vignette, Catégories, Activités) ; un seul tiroir ouvert à la fois ; le lien de la rubrique mène toujours à la rubrique ;
   - bureau (méga-menu) : colonne « Nos modèles » ajoutée au panneau de chaque rubrique ;
   - page d'une gamme filtrée par ?rayon= : le titre dit la rubrique (« Cloudrunner · Homme »).
   Idempotent (data-on-menu). */
(function () {
  var NOMS = { homme: 'Homme', femme: 'Femme', enfant: 'Enfant' };
  var PLUS = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/><path class="v" d="M12 5v14"/></svg>';
  function rubrique(a) { var m = (a.getAttribute('href') || '').match(/^\/collections\/(homme|femme|enfant)\/?$/); return m ? m[1] : ''; }
  function init() {
    var tpl = document.getElementById('onMenuTiroirs');
    if (!tpl || tpl.dataset.onMenu) return;
    tpl.dataset.onMenu = '1';
    var src = tpl.content;
    // Mobile
    Array.prototype.forEach.call(document.querySelectorAll('#mnav a.mnav__rayon'), function (a) {
      var r = rubrique(a), t = r && src.querySelector('.mnav__tiroir[data-rayon="' + r + '"]');
      if (!t) return;
      var ligne = document.createElement('div'); ligne.className = 'mnav__ligne';
      a.parentNode.insertBefore(ligne, a); ligne.appendChild(a);
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mnav__plus'; b.innerHTML = PLUS;
      b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', t.id); b.setAttribute('aria-label', 'Déplier ' + (NOMS[r] || r));
      ligne.appendChild(b);
      ligne.parentNode.insertBefore(t, ligne.nextSibling);
      b.addEventListener('click', function () {
        var ouvert = b.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(document.querySelectorAll('#mnav .mnav__plus[aria-expanded="true"]'), function (x) {
          if (x === b) return; x.setAttribute('aria-expanded', 'false'); x.setAttribute('aria-label', x.getAttribute('aria-label').replace('Replier', 'Déplier'));
          var tt = document.getElementById(x.getAttribute('aria-controls')); if (tt) tt.hidden = true;
        });
        b.setAttribute('aria-expanded', String(!ouvert));
        b.setAttribute('aria-label', (ouvert ? 'Déplier ' : 'Replier ') + (NOMS[r] || r));
        t.hidden = ouvert;
      });
    });
    // Bureau
    Array.prototype.forEach.call(document.querySelectorAll('#hdr .nav > li.has-sub'), function (li) {
      var a = li.querySelector('a'), r = a && rubrique(a), col = r && src.querySelector('.mega__col--modeles[data-rayon="' + r + '"]');
      var sub = li.querySelector('.sub');
      if (col && sub) sub.appendChild(col);
    });
    // Titre d'une gamme filtrée par rubrique
    var r = new URLSearchParams(location.search).get('rayon'), h1 = document.getElementById('collTitre');
    if (h1 && NOMS[r] && !h1.dataset.onRayon) { h1.dataset.onRayon = '1'; h1.textContent = h1.textContent.trim() + ' · ' + NOMS[r]; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
